// @flow
import React from 'react';

import GroupChatSeen from './GroupChatSeen';
import { downloadResource } from '../../models/Downloader';

type Props = {
  id: number,
  message: string,
  timestamp: string,
  profilePictureURL: string,
  attachmentName: string,
  attachmentURL: string,
  loading: boolean,
  other: boolean,
  senderName: string,
  numberOfSeenMember: number,
  groupChatId: number,
  groupChatSize: number,
  viewerId: number,
  viewerType: string,
  onMentionClick: (e: any) => void,
};

const MENTION_RAW_REGEX = /\[TO id:(\d+) type:(\w+?)\](.+?)\[\/TO\]/g;
const ATTACHMENT_RAW_REGEX = /\[FILE\/\]/g;

export default class ChatMessage extends React.PureComponent<Props> {
  renderMessage(
    rawMessage: string,
    readerId: number,
    viewerType: string,
    attachmentName: string = '',
  ): string {
    return rawMessage
      .replace(MENTION_RAW_REGEX, (match, id, type, name) => {
        let classes = 'mention';
        if (id == readerId && type === viewerType) {
          classes += ' me';
        }
        return `<div data-mention-id="${id}" data-type="${type}" contenteditable="false" class="${classes}">TO ${name}</div>`;
      })
      .replace(ATTACHMENT_RAW_REGEX, () => {
        return `<div class="attachment">${attachmentName}</div>`;
      });
  }

  onMentionClick = (e: any) => {
    if (e.target.getAttribute('data-mention-id')) {
      this.props.onMentionClick &&
        this.props.onMentionClick({
          mentionId: +e.target.getAttribute('data-mention-id'),
          type: e.target.getAttribute('data-type'),
        });
    }
  };

  render() {
    const {
      id,
      message,
      timestamp,
      profilePictureURL,
      attachmentName,
      attachmentURL,
      other = false,
      loading = false,
      senderName,
      numberOfSeenMember,
      groupChatSize,
      groupChatId,
      viewerId,
      viewerType,
    } = this.props;
    return (
      <div
        className={`chat-message ${
          other
            ? 'chat-message--left chat-message--other'
            : 'chat-message--right'
        }`}
      >
        {other && (
          <img className="chat-message__avatar" src={profilePictureURL} />
        )}
        <div className="chat-message__content">
          {other && <div className="chat-message__sender">{senderName}</div>}
          <div className="chat-message__main">
            {!other && (
              <GroupChatSeen
                id={id}
                groupChatId={groupChatId}
                numberOfSeenMember={numberOfSeenMember}
                groupChatSize={groupChatSize}
                className="chat-message__member-seen"
              />
            )}
            <div
              className={
                'chat-message__loader ' +
                (loading ? '' : 'chat-message__loader--hide')
              }
            />
            <div className="chat-message__bubble" onClick={this.onMentionClick}>
              <div
                onClick={() => downloadResource(attachmentURL, attachmentName)}
                dangerouslySetInnerHTML={{
                  __html: this.renderMessage(
                    message,
                    viewerId,
                    viewerType,
                    attachmentName,
                  ),
                }}
              />
            </div>
          </div>
          <div className="chat-message__timestamp">{timestamp}</div>
        </div>
      </div>
    );
  }
}
